import isDate from "lodash/fp/isDate";
import isString from "lodash/fp/isString";
import isFunction from "lodash/fp/isFunction";
import isNil from "lodash/fp/isNil";
import moment from "moment";
import constants from "../../../core/constants";
class Controller {
  constructor(
    $mdDialog,
    $injector,
    $stateParams,
    City,
    localStorageService,
    Backup,
    ride,
    Events
  ) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.page = $stateParams.page;
    this.manualBackupsLimit = $stateParams.limit;
    this.Backup = Backup;
    this.BackupRecommendation = $injector.get("BackupRecommendation");
    this.RideBackupsTransform = $injector.get("RideBackupsTransform");
    this.ride = ride;
    this.selectedBackup = ride.backup ? ride.backup._id : null;
    this.Ride = $injector.get("Ride");
    this.rideDate = ride.date.value;
    this.rideId = ride._id.value;
    this.Events = Events;
    this.filterEvent = Events.getFilterEvent("rideBackups");
    this.paginateEvent = Events.getPaginateEvent("rideBackups");
    this.errorNotificationEvent = Events.eventsType.onShowErrorNotification;
    this.confirmEvent = Events.getUpdateEvent("confirmEvent");
    this.localStorageService = localStorageService;

    this.Lists = $injector.get("Lists");
    // Get ride category per city
    this.City = City;
    this.getRideCategoriesEvent = Events.getUpdateEvent("getRideCategories");

    this.operator = this.localStorageService.get("authdata");
    this.ridesRefreshCount =
      this.localStorageService.get("ridesRefreshCount") || {};
    this.ridesRefreshCount[this.rideId] =
      this.ridesRefreshCount[this.rideId] || 0;

    this.onClickForward = () => false;
    this.backupStatuses = {
      1000: "newlyCreated",
      1001: "processing",
      1002: "success",
      1003: "noMatch",
      1004: "error",
      1005: "unreported",
      1006: "unsupportedConf",
      1007: "notInTimeWindow",
      1008: "eventExpired",
    };
    this.recommendedBackupLoading = true;
  }

  $onInit() {
    this.Events.on(this.confirmEvent, this.confirm.bind(this));
    this.getRecommendedBackups();
    this.getRideCategory(this.ride.city.value);

    this.refreshBackup = () => {
      this.recommendedBackupLoading = true;
      this.BackupRecommendation.refreshBackupRecommendation(
        this.ride._id.value,
        { backup_id: this.backupRecommendation.id }
      ).$promise.then(
        () => {
          this.getBackupStatus({ refresh: true });
        },
        (res) => {
          this.noBackupRecommendation = res.data;
          this.Events.emit(this.errorNotificationEvent, res.data);
        }
      );
    };

    const showConfirmDialog = (title, confirmClick) =>
      this.$mdDialog
        .confirm()
        .title(title)
        .multiple(true)
        .ok(confirmClick || "Yes")
        .cancel("Cancel");

    this.assignBackup = () => {
      const { reason } = this;
      const confirmationDialog = showConfirmDialog(
        `Are you sure you want to assign this backup recommendation to this ride?`
      );
      this.$mdDialog.show(confirmationDialog).then(
        () => {
          this.$mdDialog.hide({ reason, backup: this.backupRecommendation.id });
          this.analyseAssignBackup(
            "assign_backup",
            this.backupRecommendation.id
          );
        },
        () => {}
      );
    };
    let dateStr;
    if (isDate(this.rideDate)) {
      dateStr = this.rideDate;
    } else if (isString(this.rideDate)) {
      dateStr = new Date(this.rideDate);
    } else if (isFunction(this.rideDate.toDate)) {
      dateStr = this.rideDate.toDate();
    }
    this.Backup.getAll({ available: dateStr, limit: 0 }).$promise.then(
      (response) => {
        this.availableBackups = this.RideBackupsTransform.justify(
          response.hits
        );

        if (!isNil(this.ride.backup) && !isNil(this.ride.backup._id)) {
          const usedRide = this.availableBackups.find(
            (backup) => backup._id === this.ride.backup._id
          );

          if (!isNil(usedRide)) usedRide.used = true;
        }
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }

  justifyBackup(backup) {
    backup.distance = (backup.distance / 1000).toFixed(2);
    backup.eta = (backup.eta / 60).toFixed(2);

    return backup;
  }
  checkAndSetTiming(newTiming) {
    if (newTiming < 0) {
      this.recommendationTimeLeft = parseFloat(
        ((newTiming * -1) / constants.fromMilliToMin).toFixed(0)
      );
    }
  }
  getRecommendedBackups() {
    this.BackupRecommendation.getBackupRecommendation(this.ride._id.value)
      .$promise.then(
        (res) => {
          const that = this;
          const statusActions = {
            processing() {
              that.getBackupStatus();
            },
            newlyCreated() {
              that.getBackupStatus();
            },
            unreported() {
              that.noBackupRecommendation = res.error;
              that.recommendedBackupLoading = false;
            },
            eventExpired() {
              that.noBackupRecommendation = res.error;
              that.recommendedBackupLoading = false;
            },
          };
          if (statusActions[this.backupStatuses[res.code]]) {
            statusActions[this.backupStatuses[res.code]]();
          }
        },
        (res) => {
          res.data.message = res.data.detail;
          this.noBackupRecommendation = res.data;
          this.Events.emit(this.errorNotificationEvent, res.data);
          this.recommendedBackupLoading = false;
        }
      )
      .catch(() => {
        this.recommendedBackupLoading = false;
      });
  }
  getBackupStatus(params) {
    const refresh = params ? params.refresh : null;
    const id = this.ride._id.value;
    this.BackupRecommendation.getBackupStatus(id).$promise.then(
      (res) => {
        const retryAfter = res.headers["Retry-After"] || 5000;
        const data = res.data;
        this.backupRecommendationAnalysis = this.getRecommendationAnalysis(
          data.backup
        );
        const eventType = refresh
          ? "refresh_recommendation"
          : "get_recommendation";

        const that = this;
        const statusActions = {
          processing() {
            setTimeout(() => that.getBackupStatus(params), retryAfter);
          },
          newlyCreated() {
            setTimeout(() => that.getBackupStatus(params), retryAfter);
          },
          success() {
            that.recommendedBackupLoading = false;
            that.backupRecommendation = that.justifyBackup(data.backup.backup);
            that.analyseAssignBackup(eventType);
          },
          reportNotInTimeWindow() {
            that.analyseAssignBackup(eventType);
            that.recommendedBackupLoading = false;
            that.outsideTimeWindow = data.error;
          },
          notInTimeWindow() {
            if (data.backup ? data.backup.ride_assignment : false) {
              const newTiming =
                new Date() - moment(data.backup.ride_assignment).toDate();
              that.checkAndSetTiming(newTiming);
            }
            this.reportNotInTimeWindow();
          },
          noMatch() {
            that.analyseAssignBackup(eventType);
            that.recommendedBackupLoading = false;
            that.noBackupRecommendation = data.error;
          },
          nonreportableErr() {
            that.recommendedBackupLoading = false;
            that.noBackupRecommendation = data.error;
          },
        };
        statusActions[this.backupStatuses[data.code]]
          ? statusActions[this.backupStatuses[data.code]]()
          : statusActions.nonreportableErr();
      },
      (res) => {
        this.noBackupRecommendation = res.data.error;
        this.Events.emit(this.errorNotificationEvent, res.data.data);
      }
    );
  }
  getRideCategory(cityId) {
    this.Lists.all.rideCategoryList = [];
    this.City.getRideCategory({ city: cityId }).$promise.then((response) => {
      if (response.hits) {
        this.Lists.all.rideCategoryList = response.hits.map(
          ({ _id: name, _source: category }) => ({
            name,
            title: `${category.ride_type} ${category.service_type}`,
            param: "category",
          })
        );
      }
      this.Events.emit(this.getRideCategoriesEvent);
    });
  }

  confirm() {
    const { reason } = this;
    this.$mdDialog.hide({
      reason,
      backup: this.RideBackupsTransform.selectedBackup,
    });
    this.analyseAssignBackup(
      "assign_backup",
      this.RideBackupsTransform.selectedBackup
    );
  }

  close() {
    this.$mdDialog.cancel();
  }

  // Analyse of the complete emergency handling experience

  updateRideRefreshCount() {
    this.localStorageService.set("ridesRefreshCount", this.ridesRefreshCount);
  }

  removeParamAndDestruct(toBeRemoved, obj) {
    if (!obj) return {};
    const { [toBeRemoved]: remove, ...rest } = obj;
    return rest;
  }

  analyseAssignBackup(eventType, backupId = null) {
    if (this.backupRecommendationAnalysis === undefined) return;
    const analysisObject = {
      type: eventType,
      recommendation: this.removeParamAndDestruct(
        "use_live_location",
        this.backupRecommendationAnalysis
      ),
      ride_id: this.rideId,
      operator_id: this.operator.owner,
      manual_backups_count: this.availableBackups
        ? this.availableBackups.length
        : 0,
      use_live_location: this.backupRecommendationAnalysis.use_live_location,
    };

    this.handleAssignBackupEvents(eventType, analysisObject, backupId);
  }

  handleAssignBackupEvents(eventType, analysisObject, backupId = null) {
    if (eventType === "refresh_recommendation") {
      analysisObject.refresh_count = ++this.ridesRefreshCount[this.rideId];
    }

    if (eventType === "assign_backup") {
      analysisObject.refresh_count = this.ridesRefreshCount[this.rideId];
      analysisObject.backup_id = backupId;
      delete this.ridesRefreshCount[this.rideId];
    }

    if (eventType === "get_recommendation") {
      analysisObject.refresh_count = this.ridesRefreshCount[this.rideId];
    }

    this.Ride.analyseBackup(analysisObject);
    this.updateRideRefreshCount();
  }

  getRecommendationAnalysis(recommendationResponse) {
    recommendationResponse = recommendationResponse || {};
    const recommendationAnalysisObject = {
      ride_id: recommendationResponse.ride_id,
      use_live_location: recommendationResponse.use_live_location,
    };

    if (recommendationResponse.error) {
      recommendationAnalysisObject.error = recommendationResponse.error;
    }

    if (recommendationResponse.ride_assignment) {
      recommendationAnalysisObject.ride_assignment =
        recommendationResponse.ride_assignment;
    }

    if (recommendationResponse.backup) {
      const backup = recommendationResponse.backup;
      const busType = backup.bus_type;

      recommendationAnalysisObject.backup = {
        id: backup.id,
        name: backup.name,
        distance: backup.distance,
        eta: backup.eta,
        phone: backup.phone,
        lat: backup.lat,
        lng: backup.lng,
        location_timestamp: backup.location_timestamp,
        bus_type: {
          id: busType ? busType.id : null,
          name: busType ? busType.name : null,
          max_seats: busType ? busType.max_seats : null,
        },
      };
    }

    return recommendationAnalysisObject;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/ride/assignBackupDialog/assignBackupDialog.controller.js